module.exports = __webpack_public_path__ + "static/media/pc-02.ce92374c.svg";